import type { UseQueryOptions } from '@/modules/query-client/types/UseQueryOptions';
import type {
  DefaultError,
  QueryKey,
  // eslint-disable-next-line no-restricted-imports -- this is the file which overrides the @tanstack/react-query types
  UseQueryOptions as TanstackUseQueryOptions,
} from '@tanstack/react-query';
import isEmptyString from '@thisisdmg/tirecloud-patterns/v2/functions/isEmptyString';
import { omit } from 'lodash-es';

export default function createQueryOptions<
  TQueryFnData = unknown,
  TVariables = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>({
  queryKey,
  useLangInQueryKey = true,
  lang,
  ...options
}: UseQueryOptions<
  TQueryFnData,
  TVariables,
  TError,
  TData,
  TQueryKey
>): TanstackUseQueryOptions<TData, TError, TData, TQueryKey> {
  return {
    // I think this is safe since queryKey are always arrays
    queryKey: [
      ...(queryKey ?? []),
      ...(useLangInQueryKey && !isEmptyString(lang) ? [lang] : []),
    ] as unknown as TQueryKey,
    ...omit(options, 'variables'),
  };
}
